// EXTERNAL
import { Link } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
// COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
// ASSETS
import betaLogo from "../../../../assets/beta-logo.png";
// CONTEXT
import { useCreativeDispatch } from "../../../../contexts/creative.context";
// TYPES
import { PageHeaderProps } from "../types";
// CONFIGS
import config from "../../../../configs/config";
// LIBS
import { analytics_record } from "../../../../libs/amplify";
import { Google_Analytics_Event } from "../../../../libs/google-analytics";
// HELPERS
import { setCreativeTTB } from "../../../../helpers/time_to_build";
import { create_new_time_isostring } from "../../../../helpers/format_time";

// Holds components for everything above search bar
export function PageHeader({ advertiserIdParams, advertiserName, user, handleOpenReportingModal }: PageHeaderProps) {
  const creativeDispatch = useCreativeDispatch();
  const NEWCREATIVEID = uuidv4();
  return (
    <>
      <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={4} />
      <div className="flex flex-row justify-between">
        <div className="flex items-center justify-center" data-testid="left-arrow-button">
          {advertiserIdParams && (
            <Link
              className="no-underline white"
              to={{
                pathname: `/library/${user.teamId}/`,
                key: uuidv4(),
              }}>
              <ComponentLibrary.PCActionButton
                textColor={"mid-gray"}
                color={"bg-transparent"}
                width={"w-100"}
                height={"36px"}
                text={<ComponentLibrary.PCIconPicker icon={"arrow-left-long"} size={"2xl"} />}
                clickHandler={() => {
                  creativeDispatch({
                    type: "RESET_CREATIVE_DATA",
                    payload: undefined,
                  });
                }}
              />
            </Link>
          )}
          <ComponentLibrary.PCTableTitle fontWeight={"fw5"} color="dark-gray" inlineStyles={{ fontSize: "29px" }} text={(!advertiserIdParams && "Library") || advertiserName} />
        </div>
        {/* Render a different type of button depending on type of page  */}
        <div className="relative">
          {advertiserIdParams && !config.managedServiceTeamIds.includes(user.teamId) ? (
            <div>
              <img src={betaLogo} className="absolute z-1 w2 top--1 right--1" />
              <ComponentLibrary.PCActionButton
                text={"Request Campaign Report"}
                clickHandler={async (e: any) => {
                  e.preventDefault();
                  await handleOpenReportingModal?.("campaign", "");
                }}
                iconRight={"chart-column"}
                width={"w5"}
                height={"36px"}
              />
            </div>
          ) : (
            <Link
              className="no-underline white"
              to={{
                pathname: `/creative/${NEWCREATIVEID}`,
                search: "?new",
              }}>
              <ComponentLibrary.PCActionButton
                textColor={"white"}
                color={"background-color-primary-3"}
                width={"w-100"}
                height={"38px"}
                text={
                  <>
                    <ComponentLibrary.PCIconPicker icon={"plus"} utilityClasses={"mr3"} size={"lg"} />
                    <span className="fw4" style={{ fontSize: "15px" }}>
                      New ad
                    </span>
                  </>
                }
                clickHandler={() => {
                  Google_Analytics_Event({ name: "create_new_ad", category: "ad_creative", action: "start", label: NEWCREATIVEID });
                  setCreativeTTB("id", NEWCREATIVEID);
                  setCreativeTTB("startTime", create_new_time_isostring());
                  if (config.analytics.DISABLED === false && user.teamId !== "pi6j") {
                    analytics_record({
                      name: `createad_start`,
                      attributes: {
                        eventType: "click",
                        userId: `${user.id}`,
                        userEmail: `${user.email}`,
                        creativeId: NEWCREATIVEID,
                        teamId: `${user.teamId}`,
                        teamName: `${user.teamName}`,
                        advertiserId: advertiserIdParams || ``,
                        advertiserName: advertiserName || ``,
                      },
                    });
                  }
                  creativeDispatch({
                    type: "RESET_CREATIVE_DATA",
                    payload: undefined,
                  });
                }}
              />
            </Link>
          )}
        </div>
      </div>
      <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={5} />
    </>
  );
}
